export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: DateTime; output: DateTime; }
  Decimal: { input: Decimal; output: Decimal; }
  JsonValue: { input: JsonValue; output: JsonValue; }
  Key: { input: Key; output: Key; }
  Long: { input: Long; output: Long; }
  Milliseconds: { input: Milliseconds; output: Milliseconds; }
  SemverVersion: { input: SemverVersion; output: SemverVersion; }
}

export interface AddDataCellInput {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['JsonValue']['input']>;
}

export interface AddDataTableInput {
  name: Scalars['String']['input'];
  rows: Array<Array<AddDataCellInput>>;
}

export enum AggregateFunction {
  All = 'All',
  Any = 'Any',
  Average = 'Average',
  Checksum = 'Checksum',
  Count = 'Count',
  DistinctCount = 'DistinctCount',
  DistinctValues = 'DistinctValues',
  Entropy = 'Entropy',
  First = 'First',
  Histogram = 'Histogram',
  Last = 'Last',
  Length = 'Length',
  Max = 'Max',
  Median = 'Median',
  Min = 'Min',
  MostFrequent = 'MostFrequent',
  NonNullCount = 'NonNullCount',
  PopulationVariance = 'PopulationVariance',
  Product = 'Product',
  Single = 'Single',
  StdDev = 'StdDev',
  Sum = 'Sum',
  Values = 'Values',
  Variance = 'Variance'
}

export interface AggregateTransformInput {
  aggregate: Array<InputMaybe<AggregatedFieldDefInput>>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface AggregatedFieldDefInput {
  as?: InputMaybe<Scalars['String']['input']>;
  field: Scalars['String']['input'];
  op: AggregateFunction;
}

export interface ApiKey {
  __typename?: 'ApiKey';
  createdDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  transactionPackage: TransactionPackage;
  value: Scalars['String']['output'];
}

export interface ApiKeyControlViewModel {
  __typename?: 'ApiKeyControlViewModel';
  apiKey?: Maybe<ApiKeyViewModel>;
  apiKeys?: Maybe<Array<ApiKeyViewModel>>;
}


export interface ApiKeyControlViewModelapiKeyArgs {
  apiKeyId?: InputMaybe<Scalars['String']['input']>;
}


export interface ApiKeyControlViewModelapiKeysArgs {
  transactionPackage?: InputMaybe<TransactionPackage>;
}

export interface ApiKeyControlViewModelMutations {
  __typename?: 'ApiKeyControlViewModelMutations';
  addApiKey?: Maybe<ApiKeyViewModel>;
  removeApiKey?: Maybe<ApiKeyViewModel>;
  update?: Maybe<ApiKeyViewModel>;
  updateLegacyServiceProductsToPeriodBased?: Maybe<Array<Maybe<SolutionServiceProductViewModel>>>;
}


export interface ApiKeyControlViewModelMutationsaddApiKeyArgs {
  apiKeyDefinition?: InputMaybe<ApiKeyDefinitionInput>;
}


export interface ApiKeyControlViewModelMutationsremoveApiKeyArgs {
  apiKeyId?: InputMaybe<Scalars['String']['input']>;
}


export interface ApiKeyControlViewModelMutationsupdateArgs {
  apiKeyDefinition?: InputMaybe<ApiKeyDefinitionInput>;
  apiKeyId?: InputMaybe<Scalars['String']['input']>;
}

export interface ApiKeyDefinitionInput {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  transactionPackage: TransactionPackage;
}

export interface ApiKeyViewModel {
  __typename?: 'ApiKeyViewModel';
  attachedServiceProducts: Array<SolutionServiceProductViewModel>;
  createdDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  transactionPackage: TransactionPackage;
  value: Scalars['String']['output'];
}

export interface AuditEntry {
  __typename?: 'AuditEntry';
  action: Scalars['String']['output'];
  changeDetails?: Maybe<Scalars['String']['output']>;
  changedAt: DateTimeOffset;
  changedBy: Scalars['String']['output'];
  entityId: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  queryDetails?: Maybe<Scalars['String']['output']>;
}

export interface BaseUser {
  __typename?: 'BaseUser';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
}

export interface CalculateTransformInput {
  as: Scalars['String']['input'];
  expression: Scalars['String']['input'];
}

export interface Calculation {
  __typename?: 'Calculation';
  detail: CalculationDetail;
  id: Scalars['ID']['output'];
  inputData: TableSetReference;
  resultData?: Maybe<TableSetReference>;
}

export interface CalculationDetail {
  __typename?: 'CalculationDetail';
  completed?: Maybe<Scalars['DateTime']['output']>;
  created: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Array<KeyValuePair__String_String>>;
  started?: Maybe<Scalars['DateTime']['output']>;
  state: JobState;
  username: BaseUser;
  worker?: Maybe<Scalars['String']['output']>;
}

export enum CalculationMode {
  Async = 'Async',
  Sync = 'Sync'
}

export enum CalculationModeFilter {
  All = 'All',
  Async = 'Async',
  Sync = 'Sync'
}

export interface CalculationRuleViewModel {
  __typename?: 'CalculationRuleViewModel';
  dataDependencies: Array<DataScope>;
  schema?: Maybe<UseCaseSchema>;
}

export enum CalculationStatus {
  Failed = 'Failed',
  Successful = 'Successful'
}

export interface CapacityViewModel {
  __typename?: 'CapacityViewModel';
  computeCapacityStatus: ComputeCapacityStatus;
  maxCapacity: Scalars['Int']['output'];
  minCapacity: Scalars['Int']['output'];
}

export enum CellErrorFilter {
  All = 'All',
  InvalidOnly = 'InvalidOnly',
  ValidOnly = 'ValidOnly'
}

export enum CellErrorHandling {
  DefaultValue = 'DefaultValue',
  Inline = 'Inline'
}

export interface ChangedColumn {
  __typename?: 'ChangedColumn';
  from: ColumnSchema;
  to: ColumnSchema;
}

export interface ChangedTable {
  __typename?: 'ChangedTable';
  changedColumns: Array<ChangedColumn>;
  displayName?: Maybe<Scalars['String']['output']>;
  missingColumns: Array<ColumnSchema>;
  name: Scalars['String']['output'];
  newColumns: Array<ColumnSchema>;
}

export interface ChargedServiceProductIdentifier {
  __typename?: 'ChargedServiceProductIdentifier';
  id: Scalars['ID']['output'];
  period?: Maybe<Scalars['Int']['output']>;
}

export interface ColumnSchema {
  __typename?: 'ColumnSchema';
  displayName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nullable: Scalars['Boolean']['output'];
  typeName: Scalars['String']['output'];
}

export interface ColumnSchemaViewModel {
  __typename?: 'ColumnSchemaViewModel';
  displayName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nullable: Scalars['Boolean']['output'];
  typeName: Scalars['String']['output'];
}

export interface ComputeCapacityStatus {
  __typename?: 'ComputeCapacityStatus';
  available: Scalars['Int']['output'];
  desired: Scalars['Int']['output'];
  inUse: Scalars['Int']['output'];
  running: Scalars['Int']['output'];
}

export interface Configuration {
  __typename?: 'Configuration';
  getReadmeOss?: Maybe<ReadmeOssContentViewModel>;
  instance?: Maybe<Scalars['String']['output']>;
  keys?: Maybe<Array<Maybe<ConfigurationKeyViewModel>>>;
}

export interface ConfigurationKeyViewModel {
  __typename?: 'ConfigurationKeyViewModel';
  aliases?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  caption?: Maybe<Scalars['String']['output']>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  range?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
}

export enum CostType {
  FIXED = 'FIXED',
  VARIABLE = 'VARIABLE'
}

export enum Currency {
  AED = 'AED',
  AFN = 'AFN',
  ALL = 'ALL',
  AMD = 'AMD',
  ANG = 'ANG',
  AOA = 'AOA',
  ARS = 'ARS',
  AUD = 'AUD',
  AWG = 'AWG',
  AZN = 'AZN',
  BAM = 'BAM',
  BBD = 'BBD',
  BDT = 'BDT',
  BGN = 'BGN',
  BHD = 'BHD',
  BIF = 'BIF',
  BMD = 'BMD',
  BND = 'BND',
  BOB = 'BOB',
  BRL = 'BRL',
  BSD = 'BSD',
  BTN = 'BTN',
  BWP = 'BWP',
  BYN = 'BYN',
  BZD = 'BZD',
  CAD = 'CAD',
  CDF = 'CDF',
  CHF = 'CHF',
  CLP = 'CLP',
  CNY = 'CNY',
  COP = 'COP',
  CRC = 'CRC',
  CUP = 'CUP',
  CVE = 'CVE',
  CZK = 'CZK',
  DEM = 'DEM',
  DJF = 'DJF',
  DKK = 'DKK',
  DOP = 'DOP',
  DZD = 'DZD',
  EEK = 'EEK',
  EGP = 'EGP',
  ERN = 'ERN',
  ETB = 'ETB',
  EUR = 'EUR',
  FIM = 'FIM',
  FJD = 'FJD',
  FRF = 'FRF',
  GBP = 'GBP',
  GEL = 'GEL',
  GHS = 'GHS',
  GIP = 'GIP',
  GMD = 'GMD',
  GNF = 'GNF',
  GRD = 'GRD',
  GTQ = 'GTQ',
  GYD = 'GYD',
  HKD = 'HKD',
  HNL = 'HNL',
  HRK = 'HRK',
  HTG = 'HTG',
  HUF = 'HUF',
  IDR = 'IDR',
  ILS = 'ILS',
  INR = 'INR',
  IQD = 'IQD',
  IRR = 'IRR',
  ISK = 'ISK',
  JMD = 'JMD',
  JOD = 'JOD',
  JPY = 'JPY',
  KES = 'KES',
  KGS = 'KGS',
  KHR = 'KHR',
  KMF = 'KMF',
  KRW = 'KRW',
  KWD = 'KWD',
  KYD = 'KYD',
  KZT = 'KZT',
  LAK = 'LAK',
  LBP = 'LBP',
  LKR = 'LKR',
  LRD = 'LRD',
  LSL = 'LSL',
  LTL = 'LTL',
  LVL = 'LVL',
  LYD = 'LYD',
  MAD = 'MAD',
  MDL = 'MDL',
  MGA = 'MGA',
  MKD = 'MKD',
  MMK = 'MMK',
  MNT = 'MNT',
  MOP = 'MOP',
  MRU = 'MRU',
  MUR = 'MUR',
  MVR = 'MVR',
  MWK = 'MWK',
  MXN = 'MXN',
  MYR = 'MYR',
  MZN = 'MZN',
  NAD = 'NAD',
  NGN = 'NGN',
  NIO = 'NIO',
  NOK = 'NOK',
  NPR = 'NPR',
  NZD = 'NZD',
  OMR = 'OMR',
  PAB = 'PAB',
  PEN = 'PEN',
  PGK = 'PGK',
  PHP = 'PHP',
  PKR = 'PKR',
  PLN = 'PLN',
  PYG = 'PYG',
  QAR = 'QAR',
  RON = 'RON',
  RSD = 'RSD',
  RUB = 'RUB',
  RWF = 'RWF',
  SAR = 'SAR',
  SBD = 'SBD',
  SCR = 'SCR',
  SDG = 'SDG',
  SEK = 'SEK',
  SGD = 'SGD',
  SHP = 'SHP',
  SIT = 'SIT',
  SKK = 'SKK',
  SLL = 'SLL',
  SOS = 'SOS',
  SRD = 'SRD',
  SSP = 'SSP',
  STN = 'STN',
  SYP = 'SYP',
  SZL = 'SZL',
  THB = 'THB',
  TJS = 'TJS',
  TMT = 'TMT',
  TND = 'TND',
  TOP = 'TOP',
  TRY = 'TRY',
  TTD = 'TTD',
  TWD = 'TWD',
  TZS = 'TZS',
  UAH = 'UAH',
  UGX = 'UGX',
  USD = 'USD',
  UYU = 'UYU',
  UZS = 'UZS',
  VES = 'VES',
  VND = 'VND',
  VUV = 'VUV',
  WST = 'WST',
  XAF = 'XAF',
  XCD = 'XCD',
  XOF = 'XOF',
  XPF = 'XPF',
  YER = 'YER',
  ZAR = 'ZAR',
  ZMW = 'ZMW',
  ZWL = 'ZWL'
}

export interface DataScope {
  __typename?: 'DataScope';
  icon: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface DataSetDataModelInput {
  name: Scalars['String']['input'];
  rows: Array<InputMaybe<Array<InputMaybe<Scalars['JsonValue']['input']>>>>;
}

export interface DataSetQueryInput {
  distinct?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  rename?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  select?: InputMaybe<Scalars['String']['input']>;
  skip: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
}

export interface DataSetSchemaViewModel {
  __typename?: 'DataSetSchemaViewModel';
  columns: Array<ColumnSchemaViewModel>;
  displayName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
}

export interface DataSetTransformModelInput {
  /** @deprecated Will be replaced by transforms. */
  query?: InputMaybe<DataSetQueryInput>;
  tableName: Scalars['String']['input'];
  transforms: Array<TransformCollectionInput>;
}

export interface DataSetViewModel {
  __typename?: 'DataSetViewModel';
  rowCount: Scalars['Int']['output'];
  rows?: Maybe<Array<Maybe<Array<Maybe<Scalars['JsonValue']['output']>>>>>;
  schema: DataSetSchemaViewModel;
}


export interface DataSetViewModelrowsArgs {
  cellErrorFilter?: InputMaybe<CellErrorFilter>;
  cellErrorHandling?: InputMaybe<CellErrorHandling>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}

export enum DataTags {
  SmallExampleData = 'SmallExampleData'
}

export interface DatabaseTemplate {
  __typename?: 'DatabaseTemplate';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export enum DateConversion {
  Date = 'Date',
  DayOfMonth = 'DayOfMonth',
  DayOfWeek = 'DayOfWeek',
  DayOfWeekIndex = 'DayOfWeekIndex',
  DayOfYear = 'DayOfYear',
  FirstOfNextWeek = 'FirstOfNextWeek',
  Hours = 'Hours',
  LastOfMonth = 'LastOfMonth',
  Minutes = 'Minutes',
  Month = 'Month',
  NextWorkingDay = 'NextWorkingDay',
  Seconds = 'Seconds',
  TimeOfDay = 'TimeOfDay',
  Week = 'Week',
  WorkingDayOfYear = 'WorkingDayOfYear',
  Year = 'Year'
}

export interface DateConversionTransformInput {
  as?: InputMaybe<Scalars['String']['input']>;
  field: Scalars['String']['input'];
  op: DateConversion;
}

export interface DateTimeOffset {
  __typename?: 'DateTimeOffset';
  date: Scalars['DateTime']['output'];
  dateTime: Scalars['DateTime']['output'];
  day: Scalars['Int']['output'];
  dayOfWeek: DayOfWeek;
  dayOfYear: Scalars['Int']['output'];
  hour: Scalars['Int']['output'];
  localDateTime: Scalars['DateTime']['output'];
  microsecond: Scalars['Int']['output'];
  millisecond: Scalars['Int']['output'];
  minute: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  nanosecond: Scalars['Int']['output'];
  now: DateTimeOffset;
  offset: Scalars['Milliseconds']['output'];
  second: Scalars['Int']['output'];
  ticks: Scalars['Long']['output'];
  timeOfDay: Scalars['Milliseconds']['output'];
  totalOffsetMinutes: Scalars['Int']['output'];
  utcDateTime: Scalars['DateTime']['output'];
  utcTicks: Scalars['Long']['output'];
  year: Scalars['Int']['output'];
}

export interface DateTimeRangeFilterInput {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
}

export enum DayOfWeek {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export enum EmailNotificationStatus {
  Failed = 'Failed',
  Processing = 'Processing',
  Sent = 'Sent',
  Triggered = 'Triggered'
}

export interface FilterDefinition {
  __typename?: 'FilterDefinition';
  column: Scalars['String']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  operator: FilterOperator;
}

export interface FilterDefinitionInputInput {
  column: Scalars['String']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  operator: FilterOperator;
}

export enum FilterOperator {
  EQ = 'EQ',
  GTE = 'GTE',
  LTE = 'LTE'
}

export interface FilterTransformInput {
  expr: Scalars['String']['input'];
}

export interface Grant {
  __typename?: 'Grant';
  apiKeyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: BaseUser;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  revoked: Scalars['Boolean']['output'];
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  revokedBy?: Maybe<BaseUser>;
  tenant: Scalars['Key']['output'];
  token: Scalars['String']['output'];
}

export interface GrantWithoutToken {
  __typename?: 'GrantWithoutToken';
  apiKeyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: BaseUser;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  revoked: Scalars['Boolean']['output'];
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  revokedBy?: Maybe<BaseUser>;
  tenant: Scalars['Key']['output'];
}

export interface Grants {
  __typename?: 'Grants';
  allGrants?: Maybe<Array<GrantWithoutToken>>;
  grant?: Maybe<GrantWithoutToken>;
  instance?: Maybe<Scalars['String']['output']>;
}


export interface GrantsallGrantsArgs {
  includeRevoked?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface GrantsgrantArgs {
  id: Scalars['ID']['input'];
}

export interface GrantsMutations {
  __typename?: 'GrantsMutations';
  createGrant?: Maybe<Grant>;
  createGrantWithApiKeyValue?: Maybe<Grant>;
  revokeGrant: Scalars['Boolean']['output'];
}


export interface GrantsMutationscreateGrantArgs {
  apiKeyId: Scalars['String']['input'];
  name: Scalars['String']['input'];
}


export interface GrantsMutationscreateGrantWithApiKeyValueArgs {
  apiKeyValue: Scalars['String']['input'];
  name: Scalars['String']['input'];
}


export interface GrantsMutationsrevokeGrantArgs {
  id: Scalars['ID']['input'];
}

export interface IS3ObjectDto {
  __typename?: 'IS3ObjectDto';
  bucketName: Scalars['String']['output'];
  eTag?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  lastModified: Scalars['DateTime']['output'];
  metaData: IS3ObjectMetaDataDto;
  size: Scalars['Long']['output'];
}

export interface IS3ObjectMetaDataDto {
  __typename?: 'IS3ObjectMetaDataDto';
  contentMD5?: Maybe<Scalars['String']['output']>;
  contentType: Scalars['String']['output'];
  creator: BaseUser;
  displayName?: Maybe<Scalars['String']['output']>;
  useCaseKey?: Maybe<Scalars['Key']['output']>;
  useCaseVersion?: Maybe<Scalars['String']['output']>;
  userDefined: Array<KeyValuePair__String_String>;
  versionId?: Maybe<Scalars['String']['output']>;
}

export enum IScopedPermission__SolutionScope {
  ArchiveAndRestoreSolution = 'ArchiveAndRestoreSolution',
  CalculateWebServices = 'CalculateWebServices',
  ChangeProjects = 'ChangeProjects',
  ChangeServiceProducts = 'ChangeServiceProducts',
  ChangeSolutionDetail = 'ChangeSolutionDetail',
  ChangeSolutionMemberPermissions = 'ChangeSolutionMemberPermissions',
  ChangeWebServiceData = 'ChangeWebServiceData',
  ChangeWebServices = 'ChangeWebServices',
  DeleteProjects = 'DeleteProjects',
  DeletePublicApiRequests = 'DeletePublicApiRequests',
  DeleteWebServices = 'DeleteWebServices',
  DownloadCalculationRule = 'DownloadCalculationRule',
  InviteSolutionMember = 'InviteSolutionMember',
  ReadAllCalculations = 'ReadAllCalculations',
  ReadAllWebServiceData = 'ReadAllWebServiceData',
  ReadProjects = 'ReadProjects',
  ReadPublicApi = 'ReadPublicApi',
  ReadPublicApiRequests = 'ReadPublicApiRequests',
  ReadServiceProducts = 'ReadServiceProducts',
  ReadSolutionDetail = 'ReadSolutionDetail',
  ReadSolutionMembers = 'ReadSolutionMembers',
  ReadTransactions = 'ReadTransactions',
  ReadWebServices = 'ReadWebServices',
  RemoveSolutionMember = 'RemoveSolutionMember'
}

export enum IScopedPermission__TenantScope {
  ChangeApiKeys = 'ChangeApiKeys',
  ChangeRateAgreements = 'ChangeRateAgreements',
  ChangeTenantMemberPermissions = 'ChangeTenantMemberPermissions',
  ChangeWorkspaces = 'ChangeWorkspaces',
  CreateSolution = 'CreateSolution',
  CreateUser = 'CreateUser',
  DeleteArchivedSolution = 'DeleteArchivedSolution',
  ManageAccessGrants = 'ManageAccessGrants',
  ReadAllSolutions = 'ReadAllSolutions',
  ReadApiKeys = 'ReadApiKeys',
  ReadCarriers = 'ReadCarriers',
  ReadConfiguration = 'ReadConfiguration',
  ReadRateAgreements = 'ReadRateAgreements',
  ReadRateDimensions = 'ReadRateDimensions',
  ReadTenantMemberPermissions = 'ReadTenantMemberPermissions',
  ReadUsers = 'ReadUsers',
  ReadWorkspaces = 'ReadWorkspaces',
  RemoveRateAgreements = 'RemoveRateAgreements',
  RemoveUser = 'RemoveUser'
}

export enum JobState {
  Completed = 'Completed',
  Failed = 'Failed',
  InProgress = 'InProgress',
  Scheduled = 'Scheduled'
}

export interface KeyValuePair__String_String {
  __typename?: 'KeyValuePair__String_String';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
}

export enum LimitType {
  Hard = 'Hard',
  Soft = 'Soft'
}

export interface Mutation {
  __typename?: 'Mutation';
  grants: GrantsMutations;
  publicApi: PublicApiMutations;
  rates: RatesMutations;
  solutions: SolutionsMutations;
  tenant: TenantMutations;
  workspaces: WorkspacesViewModelMutations;
}

export interface NextVersion {
  __typename?: 'NextVersion';
  dataDependencies: Array<DataScope>;
  releaseType: ReleaseType;
  schema?: Maybe<UseCaseSchema>;
  schemaDiff: SchemaDiffs;
  version: Scalars['String']['output'];
}

export interface NotificationDeliveryStatus {
  __typename?: 'NotificationDeliveryStatus';
  deliveryStatus: EmailNotificationStatus;
  email: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  periodNumber: Scalars['Int']['output'];
  thresholdValue: Scalars['Decimal']['output'];
  triggeredDate: Scalars['DateTime']['output'];
}

export interface NotificationTrigger {
  __typename?: 'NotificationTrigger';
  email: Scalars['String']['output'];
  thresholds: Array<Scalars['Decimal']['output']>;
}

export interface NotificationTriggerInput {
  email: Scalars['String']['input'];
  thresholds: Array<Scalars['Decimal']['input']>;
}

export enum OpenApiFormat {
  Json = 'Json',
  Yaml = 'Yaml'
}

export enum Order {
  Ascending = 'Ascending',
  Descending = 'Descending'
}

export interface PageInfo {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  pageSize: Scalars['Int']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
}

export interface PagedConnectionViewModel__TransactionViewModel {
  __typename?: 'PagedConnectionViewModel__TransactionViewModel';
  edges: Array<PagedEdgeViewModel__TransactionViewModel>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
}

export interface PagedEdgeViewModel__TransactionViewModel {
  __typename?: 'PagedEdgeViewModel__TransactionViewModel';
  cursor: Scalars['String']['output'];
  node: TransactionViewModel;
}

export interface PatchPointViewModel {
  __typename?: 'PatchPointViewModel';
  entryPath: Scalars['String']['output'];
  patcherId: Scalars['ID']['output'];
}

export interface PrimaryQuantityAxis {
  __typename?: 'PrimaryQuantityAxis';
  column: Scalars['String']['output'];
  ranges: Array<PrimaryQuantityRange>;
  unit: QuantityUnit;
}

export interface PrimaryQuantityAxisCreateInputInput {
  column: Scalars['String']['input'];
  ranges: Array<PrimaryQuantityRangeCreateInputInput>;
  unit: QuantityUnit;
}

export interface PrimaryQuantityRange {
  __typename?: 'PrimaryQuantityRange';
  costType: CostType;
  unitQuantity: Scalars['Decimal']['output'];
  upperBound?: Maybe<Scalars['Decimal']['output']>;
}

export interface PrimaryQuantityRangeCreateInputInput {
  costType?: InputMaybe<CostType>;
  unitQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  upperBound?: InputMaybe<Scalars['Decimal']['input']>;
}

export interface ProjectDefinitionInput {
  databaseTemplateId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['ID']['input'];
}

export enum ProjectState {
  Created = 'Created',
  Failed = 'Failed',
  InProgress = 'InProgress',
  Scheduled = 'Scheduled'
}

export interface ProjectViewModel {
  __typename?: 'ProjectViewModel';
  creator: BaseUser;
  databaseName?: Maybe<Scalars['String']['output']>;
  databaseProgress: Scalars['Int']['output'];
  databaseTemplateId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isAvailable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  state: ProjectState;
  streamingSessions: Array<SessionViewModel>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  workspaceId: Scalars['ID']['output'];
  workspaceName: Scalars['String']['output'];
}

export interface ProjectViewModelMutations {
  __typename?: 'ProjectViewModelMutations';
  expireUserSession: Scalars['Boolean']['output'];
}


export interface ProjectViewModelMutationsexpireUserSessionArgs {
  userName: Scalars['String']['input'];
}

export interface ProjectsViewModel {
  __typename?: 'ProjectsViewModel';
  databaseTemplates: Array<DatabaseTemplate>;
  project?: Maybe<ProjectViewModel>;
  projects: Array<ProjectViewModel>;
}


export interface ProjectsViewModelprojectArgs {
  projectId: Scalars['ID']['input'];
}

export interface ProjectsViewModelMutations {
  __typename?: 'ProjectsViewModelMutations';
  addProject?: Maybe<ProjectViewModel>;
  createStreamingUrl?: Maybe<Scalars['String']['output']>;
  deleteProject: Scalars['Boolean']['output'];
  project?: Maybe<ProjectViewModelMutations>;
  projects: Array<ProjectViewModelMutations>;
  updateProject?: Maybe<ProjectViewModel>;
}


export interface ProjectsViewModelMutationsaddProjectArgs {
  projectDefinition: ProjectDefinitionInput;
}


export interface ProjectsViewModelMutationscreateStreamingUrlArgs {
  projectId: Scalars['ID']['input'];
  refreshToken: Scalars['String']['input'];
  userType?: InputMaybe<ScsUserType>;
}


export interface ProjectsViewModelMutationsdeleteProjectArgs {
  projectId: Scalars['ID']['input'];
}


export interface ProjectsViewModelMutationsprojectArgs {
  projectId: Scalars['ID']['input'];
}


export interface ProjectsViewModelMutationsupdateProjectArgs {
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface PublicApi {
  __typename?: 'PublicApi';
  apiKeys: ApiKeyControlViewModel;
  instance?: Maybe<Scalars['String']['output']>;
}

export interface PublicApiError {
  __typename?: 'PublicApiError';
  message: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PublicApiErrorType>;
}

export enum PublicApiErrorType {
  CalculationError = 'CalculationError',
  ChargingError = 'ChargingError',
  Forbidden = 'Forbidden',
  MissingData = 'MissingData',
  MissingJobResultData = 'MissingJobResultData',
  RequestTrackingError = 'RequestTrackingError',
  TypeMismatch = 'TypeMismatch'
}

export interface PublicApiMutations {
  __typename?: 'PublicApiMutations';
  apiKeys: ApiKeyControlViewModelMutations;
}

export enum QuantityUnit {
  CBM = 'CBM',
  CFT = 'CFT',
  KG = 'KG',
  LB = 'LB',
  LDM = 'LDM'
}

export interface Query {
  __typename?: 'Query';
  configuration: Configuration;
  grants: Grants;
  publicApi: PublicApi;
  rates: Rates;
  solutions: Solutions;
  tenant: Tenant;
  workspaces: WorkspacesViewModel;
}

export interface Rate {
  __typename?: 'Rate';
  charges: Array<Scalars['Decimal']['output']>;
  deliveryLocations: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  pickupLocations: Array<Scalars['String']['output']>;
  serviceOptions: Array<Scalars['String']['output']>;
}

export interface RateAgreement {
  __typename?: 'RateAgreement';
  auditTrail: Array<AuditEntry>;
  carrier: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt: DateTimeOffset;
  lastModifiedBy: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rateTables: Array<RateTable>;
  serviceMethod: ServiceMethod;
}

export interface RateAgreementCreateInputInput {
  carrier: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  serviceMethod: ServiceMethod;
}

export interface RateAgreementUpdateInputInput {
  carrier?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  serviceMethod?: InputMaybe<ServiceMethod>;
}

export interface RateCreateInputInput {
  charges: Array<Scalars['Decimal']['input']>;
  deliveryLocations?: InputMaybe<Array<Scalars['String']['input']>>;
  pickupLocations?: InputMaybe<Array<Scalars['String']['input']>>;
  serviceOptions?: InputMaybe<Array<Scalars['String']['input']>>;
}

export interface RateDimensions {
  __typename?: 'RateDimensions';
  deliveryLocationColumns: Array<Scalars['String']['output']>;
  locationColumns: Array<Scalars['String']['output']>;
  pickupLocationColumns: Array<Scalars['String']['output']>;
  quantityColumns: Array<Scalars['String']['output']>;
  serviceOptionColumns: Array<Scalars['String']['output']>;
}

export interface RateStructure {
  __typename?: 'RateStructure';
  additionalQuantities: Array<SecondaryQuantityAxis>;
  deliveryLocationFilters: Array<FilterDefinition>;
  pickupLocationFilters: Array<FilterDefinition>;
  primaryQuantity: PrimaryQuantityAxis;
  serviceOptionFilters: Array<FilterDefinition>;
}

export interface RateStructureCreateInputInput {
  additionalQuantities?: InputMaybe<Array<SecondaryQuantityAxisCreateInputInput>>;
  deliveryLocationFilters: Array<FilterDefinitionInputInput>;
  pickupLocationFilters: Array<FilterDefinitionInputInput>;
  primaryQuantity: PrimaryQuantityAxisCreateInputInput;
  serviceOptionFilters?: InputMaybe<Array<FilterDefinitionInputInput>>;
}

export interface RateTable {
  __typename?: 'RateTable';
  currency: Currency;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rateStructure: RateStructure;
  rates: Array<Rate>;
  type: RateTableType;
  useMinimumProcedure?: Maybe<Scalars['Boolean']['output']>;
  validFrom: Scalars['DateTime']['output'];
  validTo: Scalars['DateTime']['output'];
}

export interface RateTableCreateInputInput {
  currency: Currency;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  rateStructure: RateStructureCreateInputInput;
  rates?: InputMaybe<Array<RateCreateInputInput>>;
  type: RateTableType;
  useMinimumProcedure?: InputMaybe<Scalars['Boolean']['input']>;
  validFrom: Scalars['DateTime']['input'];
  validTo: Scalars['DateTime']['input'];
}

export interface RateTablePropertiesUpdateInputInput {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  useMinimumProcedure?: InputMaybe<Scalars['Boolean']['input']>;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validTo?: InputMaybe<Scalars['DateTime']['input']>;
}

export enum RateTableType {
  MainFreight = 'MainFreight',
  Surcharge = 'Surcharge'
}

export interface RateUpdateInputInput {
  charges?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  deliveryLocations?: InputMaybe<Array<Scalars['String']['input']>>;
  pickupLocations?: InputMaybe<Array<Scalars['String']['input']>>;
  serviceOptions?: InputMaybe<Array<Scalars['String']['input']>>;
}

export interface Rates {
  __typename?: 'Rates';
  allRateAgreements: Array<RateAgreement>;
  carriers: Array<Scalars['String']['output']>;
  instance?: Maybe<Scalars['String']['output']>;
  rateAgreementById?: Maybe<RateAgreement>;
  rateDimensions: RateDimensions;
}


export interface RatesrateAgreementByIdArgs {
  rateAgreementId: Scalars['ID']['input'];
}

export interface RatesMutations {
  __typename?: 'RatesMutations';
  attachRateTable?: Maybe<RateTable>;
  createRateAgreement?: Maybe<RateAgreement>;
  removeRate: Scalars['Boolean']['output'];
  removeRateAgreement: Scalars['Boolean']['output'];
  removeRateTable: Scalars['Boolean']['output'];
  replaceRateTableRates?: Maybe<RateTable>;
  replaceRateTableStructure?: Maybe<RateTable>;
  updateRate?: Maybe<Rate>;
  updateRateAgreement?: Maybe<RateAgreement>;
  updateRateTableProperties?: Maybe<RateTable>;
}


export interface RatesMutationsattachRateTableArgs {
  input: RateTableCreateInputInput;
  rateAgreementId: Scalars['ID']['input'];
}


export interface RatesMutationscreateRateAgreementArgs {
  input: RateAgreementCreateInputInput;
}


export interface RatesMutationsremoveRateArgs {
  rateId: Scalars['ID']['input'];
}


export interface RatesMutationsremoveRateAgreementArgs {
  rateAgreementId: Scalars['ID']['input'];
}


export interface RatesMutationsremoveRateTableArgs {
  rateTableId: Scalars['ID']['input'];
}


export interface RatesMutationsreplaceRateTableRatesArgs {
  rateAgreementId: Scalars['ID']['input'];
  rateTableId: Scalars['ID']['input'];
  rates: Array<RateCreateInputInput>;
}


export interface RatesMutationsreplaceRateTableStructureArgs {
  rateAgreementId: Scalars['ID']['input'];
  rateTableId: Scalars['ID']['input'];
  structure: RateStructureCreateInputInput;
}


export interface RatesMutationsupdateRateArgs {
  input: RateUpdateInputInput;
  rateId: Scalars['ID']['input'];
}


export interface RatesMutationsupdateRateAgreementArgs {
  input: RateAgreementUpdateInputInput;
  rateAgreementId: Scalars['ID']['input'];
}


export interface RatesMutationsupdateRateTablePropertiesArgs {
  input: RateTablePropertiesUpdateInputInput;
  rateAgreementId: Scalars['ID']['input'];
  rateTableId: Scalars['ID']['input'];
}

export interface ReadmeOssContentViewModel {
  __typename?: 'ReadmeOssContentViewModel';
  fileContent?: Maybe<Scalars['String']['output']>;
}

export enum ReleaseType {
  Initial = 'Initial',
  Major = 'Major',
  Minor = 'Minor',
  Patch = 'Patch'
}

export interface ScalingPolicyViewModel {
  __typename?: 'ScalingPolicyViewModel';
  scalingAdjustment: Scalars['Int']['output'];
  scalingType: ScalingType;
  threshold: Scalars['Int']['output'];
}

export enum ScalingType {
  ScaleIn = 'ScaleIn',
  ScaleOut = 'ScaleOut'
}

export interface SchemaDiff {
  __typename?: 'SchemaDiff';
  changedTables: Array<ChangedTable>;
  missingTables: Array<TableSchema>;
  newTables: Array<TableSchema>;
}

export interface SchemaDiffs {
  __typename?: 'SchemaDiffs';
  input: SchemaDiff;
  output: SchemaDiff;
}

export enum ScopedRole__SolutionScope {
  Admin = 'Admin',
  ProjectManager = 'ProjectManager',
  PublicApiTester = 'PublicApiTester',
  User = 'User'
}

export enum ScopedRole__TenantScope {
  Admin = 'Admin',
  ApiKeyManager = 'ApiKeyManager',
  GrantsManager = 'GrantsManager',
  RatesManager = 'RatesManager',
  RatesViewer = 'RatesViewer',
  SolutionCreator = 'SolutionCreator',
  UserManager = 'UserManager',
  WorkspaceManager = 'WorkspaceManager'
}

export interface ScopedUser__SolutionScope {
  __typename?: 'ScopedUser__SolutionScope';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  permissions: Array<IScopedPermission__SolutionScope>;
  roles: Array<ScopedRole__SolutionScope>;
}

export interface ScopedUser__SolutionScopeMutations {
  __typename?: 'ScopedUser__SolutionScopeMutations';
  roles: Array<ScopedRole__SolutionScope>;
}

export interface ScopedUser__TenantScope {
  __typename?: 'ScopedUser__TenantScope';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  permissions: Array<IScopedPermission__TenantScope>;
  roles: Array<ScopedRole__TenantScope>;
}

export interface ScopedUser__TenantScopeMutations {
  __typename?: 'ScopedUser__TenantScopeMutations';
  roles: Array<ScopedRole__TenantScope>;
}

export enum ScsUserType {
  Admin = 'Admin',
  Modeler = 'Modeler',
  Standard = 'Standard',
  Viewer = 'Viewer'
}

export interface SecondaryQuantityAxis {
  __typename?: 'SecondaryQuantityAxis';
  column: Scalars['String']['output'];
  ranges: Array<SecondaryQuantityRange>;
  unit: QuantityUnit;
}

export interface SecondaryQuantityAxisCreateInputInput {
  column: Scalars['String']['input'];
  ranges: Array<SecondaryQuantityRangeCreateInputInput>;
  unit: QuantityUnit;
}

export interface SecondaryQuantityRange {
  __typename?: 'SecondaryQuantityRange';
  upperBound?: Maybe<Scalars['Decimal']['output']>;
}

export interface SecondaryQuantityRangeCreateInputInput {
  upperBound?: InputMaybe<Scalars['Decimal']['input']>;
}

export enum ServiceMethod {
  CEP = 'CEP',
  FTL = 'FTL',
  GROUPAGE = 'GROUPAGE',
  LTL = 'LTL'
}

export interface ServiceProductDetails {
  __typename?: 'ServiceProductDetails';
  allPeriods: Array<ServiceProductPeriod>;
  currentPeriod?: Maybe<ServiceProductPeriod>;
  currentPeriodNumber?: Maybe<Scalars['Int']['output']>;
  endDate: Scalars['DateTime']['output'];
  periodCount: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  status: ServiceProductStatus;
}

export interface ServiceProductPeriod {
  __typename?: 'ServiceProductPeriod';
  endDate: Scalars['DateTime']['output'];
  startDate: Scalars['DateTime']['output'];
  usedTransactionCount: Scalars['Int']['output'];
}

export interface ServiceProductPeriodInputInput {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
}

export enum ServiceProductStatus {
  Active = 'Active',
  Deactivated = 'Deactivated',
  Expired = 'Expired',
  Upcoming = 'Upcoming'
}

export interface ServiceProductViewModel {
  __typename?: 'ServiceProductViewModel';
  apiKey: ApiKeyViewModel;
  apiKeyId: Scalars['String']['output'];
  details: ServiceProductDetails;
  id: Scalars['ID']['output'];
  limitType: LimitType;
  name: Scalars['String']['output'];
  notificationDeliveryStatuses: Array<NotificationDeliveryStatus>;
  notificationTriggers: Array<NotificationTrigger>;
  services: Array<Scalars['Key']['output']>;
  transactionLimit: Scalars['Int']['output'];
}

export interface SessionViewModel {
  __typename?: 'SessionViewModel';
  isConnected: Scalars['Boolean']['output'];
  startTime: Scalars['DateTime']['output'];
  user?: Maybe<User>;
}

export interface Solution {
  __typename?: 'Solution';
  access?: Maybe<SolutionAccessViewModel>;
  archived: Scalars['Boolean']['output'];
  creationTime: Scalars['DateTime']['output'];
  creator: BaseUser;
  description: Scalars['String']['output'];
  features: SolutionFeatures;
  key: Scalars['Key']['output'];
  name: Scalars['String']['output'];
  projects?: Maybe<ProjectsViewModel>;
  useCases?: Maybe<UseCasesViewModel>;
}

export interface SolutionAccessViewModel {
  __typename?: 'SolutionAccessViewModel';
  availablePermissions: Array<IScopedPermission__SolutionScope>;
  availableRoles: Array<ScopedRole__SolutionScope>;
  me?: Maybe<ScopedUser__SolutionScope>;
  possibleMembers: Array<User>;
  users?: Maybe<Array<Maybe<ScopedUser__SolutionScope>>>;
}

export interface SolutionAccessViewModelMutations {
  __typename?: 'SolutionAccessViewModelMutations';
  availableRoles: Array<ScopedRole__SolutionScope>;
  inviteSolutionMember?: Maybe<ScopedUser__SolutionScope>;
  me?: Maybe<ScopedUser__SolutionScopeMutations>;
  removeSolutionMember?: Maybe<ScopedUser__SolutionScope>;
  updateUserRoles?: Maybe<ScopedUser__SolutionScope>;
  users?: Maybe<Array<Maybe<ScopedUser__SolutionScopeMutations>>>;
}


export interface SolutionAccessViewModelMutationsinviteSolutionMemberArgs {
  roles?: InputMaybe<Array<ScopedRole__SolutionScope>>;
  userName: Scalars['String']['input'];
}


export interface SolutionAccessViewModelMutationsremoveSolutionMemberArgs {
  userName: Scalars['String']['input'];
}


export interface SolutionAccessViewModelMutationsupdateUserRolesArgs {
  roles: Array<ScopedRole__SolutionScope>;
  userName: Scalars['String']['input'];
}

export interface SolutionDefinitionInput {
  description: Scalars['String']['input'];
  key: Scalars['Key']['input'];
  name: Scalars['String']['input'];
  projectsEnabled: Scalars['Boolean']['input'];
  useCasesEnabled: Scalars['Boolean']['input'];
}

export interface SolutionFeatures {
  __typename?: 'SolutionFeatures';
  projects: Scalars['Boolean']['output'];
  useCases: Scalars['Boolean']['output'];
}

export interface SolutionMutations {
  __typename?: 'SolutionMutations';
  access?: Maybe<SolutionAccessViewModelMutations>;
  projects?: Maybe<ProjectsViewModelMutations>;
  useCases?: Maybe<UseCasesViewModelMutations>;
}

export interface SolutionServiceProductViewModel {
  __typename?: 'SolutionServiceProductViewModel';
  serviceProduct: ServiceProductViewModel;
  solutionKey: Scalars['String']['output'];
}

export interface SolutionServiceProductsViewModel {
  __typename?: 'SolutionServiceProductsViewModel';
  serviceProduct?: Maybe<ServiceProductViewModel>;
  serviceProducts?: Maybe<Array<ServiceProductViewModel>>;
}


export interface SolutionServiceProductsViewModelserviceProductArgs {
  serviceProductId: Scalars['ID']['input'];
}

export interface SolutionServiceProductsViewModelMutations {
  __typename?: 'SolutionServiceProductsViewModelMutations';
  create?: Maybe<ServiceProductViewModel>;
  deactivate?: Maybe<ServiceProductViewModel>;
  updateNotificationTriggers?: Maybe<ServiceProductViewModel>;
}


export interface SolutionServiceProductsViewModelMutationscreateArgs {
  apiKeyId: Scalars['String']['input'];
  limitType: LimitType;
  name: Scalars['String']['input'];
  notificationTriggers?: InputMaybe<Array<NotificationTriggerInput>>;
  periods: Array<ServiceProductPeriodInputInput>;
  services: Array<Scalars['Key']['input']>;
  transactionLimit: Scalars['Int']['input'];
}


export interface SolutionServiceProductsViewModelMutationsdeactivateArgs {
  serviceProductId: Scalars['ID']['input'];
}


export interface SolutionServiceProductsViewModelMutationsupdateNotificationTriggersArgs {
  notificationTriggers: Array<NotificationTriggerInput>;
  serviceProductId: Scalars['ID']['input'];
}

export interface Solutions {
  __typename?: 'Solutions';
  allSolutions?: Maybe<Array<Solution>>;
  instance?: Maybe<Scalars['String']['output']>;
  solution?: Maybe<Solution>;
}


export interface SolutionssolutionArgs {
  solutionKey: Scalars['Key']['input'];
}

export interface SolutionsMutations {
  __typename?: 'SolutionsMutations';
  addSolution?: Maybe<Solution>;
  allSolutions?: Maybe<Array<SolutionMutations>>;
  archiveSolution?: Maybe<Solution>;
  deleteArchivedSolution?: Maybe<Solution>;
  restoreArchivedSolution?: Maybe<Solution>;
  solution?: Maybe<SolutionMutations>;
  updateSolution?: Maybe<Solution>;
}


export interface SolutionsMutationsaddSolutionArgs {
  solutionDefinition: SolutionDefinitionInput;
}


export interface SolutionsMutationsarchiveSolutionArgs {
  solutionKey: Scalars['Key']['input'];
}


export interface SolutionsMutationsdeleteArchivedSolutionArgs {
  solutionKey: Scalars['Key']['input'];
}


export interface SolutionsMutationsrestoreArchivedSolutionArgs {
  solutionKey: Scalars['Key']['input'];
}


export interface SolutionsMutationssolutionArgs {
  solutionKey: Scalars['Key']['input'];
}


export interface SolutionsMutationsupdateSolutionArgs {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  solutionKey: Scalars['Key']['input'];
}

export interface SummarizeColumnsTransformInput {
  aggregateFunctions?: InputMaybe<Array<AggregateFunction>>;
}

export interface TableSchema {
  __typename?: 'TableSchema';
  columns?: Maybe<Array<Maybe<ColumnSchema>>>;
  displayName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
}

export interface TableSetReference {
  __typename?: 'TableSetReference';
  address: Scalars['String']['output'];
  detail?: Maybe<IS3ObjectDto>;
  tableSet: TableSetViewModel;
  tableSetInPublicApiFormat?: Maybe<Scalars['String']['output']>;
  tags: Array<Maybe<Scalars['String']['output']>>;
}

export interface TableSetViewModel {
  __typename?: 'TableSetViewModel';
  /** @deprecated Query will be replaced by transforms. */
  tables: Array<Maybe<DataSetViewModel>>;
}


export interface TableSetViewModeltablesArgs {
  dataSetTransforms?: InputMaybe<Array<InputMaybe<DataSetTransformModelInput>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Tenant {
  __typename?: 'Tenant';
  access: TenantManagementAccessViewModel;
  instance?: Maybe<Scalars['String']['output']>;
}

export interface TenantManagementAccessViewModel {
  __typename?: 'TenantManagementAccessViewModel';
  availablePermissions: Array<IScopedPermission__TenantScope>;
  availableRoles: Array<ScopedRole__TenantScope>;
  me?: Maybe<ScopedUser__TenantScope>;
  users?: Maybe<Array<ScopedUser__TenantScope>>;
}

export interface TenantManagementAccessViewModelMutations {
  __typename?: 'TenantManagementAccessViewModelMutations';
  availableRoles: Array<ScopedRole__TenantScope>;
  me?: Maybe<ScopedUser__TenantScopeMutations>;
  updateUserRoles?: Maybe<ScopedUser__TenantScope>;
  users?: Maybe<Array<ScopedUser__TenantScopeMutations>>;
}


export interface TenantManagementAccessViewModelMutationsupdateUserRolesArgs {
  roles: Array<ScopedRole__TenantScope>;
  userName: Scalars['String']['input'];
}

export interface TenantMutations {
  __typename?: 'TenantMutations';
  access: TenantManagementAccessViewModelMutations;
}

export interface TimeDetails {
  __typename?: 'TimeDetails';
  completedAt: Scalars['DateTime']['output'];
  duration: Scalars['Milliseconds']['output'];
  startedAt: Scalars['DateTime']['output'];
}

export interface Transaction {
  __typename?: 'Transaction';
  apiKey?: Maybe<ApiKey>;
  calculationStatus: CalculationStatus;
  chargedServiceProduct?: Maybe<ServiceProductViewModel>;
  chargedServiceProductPeriodNumber?: Maybe<Scalars['Int']['output']>;
  requestId: Scalars['ID']['output'];
  tableName: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  transactionCount: Scalars['Int']['output'];
  useCaseKey: Scalars['Key']['output'];
  useCaseVersion: Scalars['String']['output'];
}

export interface TransactionFilterInput {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  calculationMode?: InputMaybe<CalculationModeFilter>;
  dateTimeRange?: InputMaybe<DateTimeRangeFilterInput>;
  order?: InputMaybe<Order>;
  requestId?: InputMaybe<Scalars['ID']['input']>;
  transactionStatus?: InputMaybe<TransactionStatusFilter>;
}

export enum TransactionPackage {
  Large = 'Large',
  Medium = 'Medium',
  Small = 'Small'
}

export enum TransactionStatusFilter {
  All = 'All',
  ErrorsOnly = 'ErrorsOnly',
  SuccessesOnly = 'SuccessesOnly'
}

export interface TransactionValue {
  __typename?: 'TransactionValue';
  count: Scalars['Int']['output'];
  table?: Maybe<Scalars['String']['output']>;
}

export interface TransactionViewModel {
  __typename?: 'TransactionViewModel';
  apiKey?: Maybe<ApiKey>;
  calculationMode: CalculationMode;
  chargedServiceProduct?: Maybe<ChargedServiceProductIdentifier>;
  error?: Maybe<PublicApiError>;
  id: Scalars['ID']['output'];
  payloadTableSet?: Maybe<TableSetViewModel>;
  requestedVersion?: Maybe<Scalars['String']['output']>;
  responseTableSet?: Maybe<TableSetViewModel>;
  timeDetails?: Maybe<TimeDetails>;
  transactions: Array<TransactionValue>;
}

export interface TransformCollectionInput {
  aggregate?: InputMaybe<AggregateTransformInput>;
  calculate?: InputMaybe<CalculateTransformInput>;
  dateConversion?: InputMaybe<DateConversionTransformInput>;
  filter?: InputMaybe<FilterTransformInput>;
  summarizeColumns?: InputMaybe<SummarizeColumnsTransformInput>;
}

export interface UseCaseDefinitionInput {
  calculationRuleAddress: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['Key']['input'];
  name: Scalars['String']['input'];
  tags: Array<Scalars['String']['input']>;
  transactionTable?: InputMaybe<Scalars['String']['input']>;
}

export interface UseCaseDetail {
  __typename?: 'UseCaseDetail';
  calculationRuleDownloadLink: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  key: Scalars['Key']['output'];
  name: Scalars['String']['output'];
  nextVersion?: Maybe<NextVersion>;
  releaseType: ReleaseType;
  schemaDiff?: Maybe<SchemaDiffs>;
  tags: Array<Scalars['String']['output']>;
  transactionTable?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
}


export interface UseCaseDetailnextVersionArgs {
  calculationRuleAddress: Scalars['String']['input'];
}


export interface UseCaseDetailschemaDiffArgs {
  from?: InputMaybe<Scalars['String']['input']>;
}

export interface UseCasePublicApi {
  __typename?: 'UseCasePublicApi';
  apiDocumentation?: Maybe<Array<Scalars['Int']['output']>>;
  openApiSpec?: Maybe<Scalars['String']['output']>;
  sudoApiKey?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
}


export interface UseCasePublicApiapiDocumentationArgs {
  apiKeyId?: InputMaybe<Scalars['String']['input']>;
}


export interface UseCasePublicApiopenApiSpecArgs {
  format?: InputMaybe<OpenApiFormat>;
}

export interface UseCaseSchema {
  __typename?: 'UseCaseSchema';
  input: Array<TableSchema>;
  output: Array<TableSchema>;
}

export interface UseCaseViewModel {
  __typename?: 'UseCaseViewModel';
  calculateAddress?: Maybe<TableSetViewModel>;
  calculateData?: Maybe<TableSetViewModel>;
  calculation?: Maybe<Calculation>;
  calculations?: Maybe<Array<Calculation>>;
  calculationsCount: Scalars['Int']['output'];
  data: Array<TableSetReference>;
  dataCount: Scalars['Int']['output'];
  dataDependencies: Array<DataScope>;
  detail: UseCaseDetail;
  patchPoints?: Maybe<Array<Maybe<PatchPointViewModel>>>;
  publicApi?: Maybe<UseCasePublicApi>;
  publicApiRequests?: Maybe<PagedConnectionViewModel__TransactionViewModel>;
  schema: UseCaseSchema;
}


export interface UseCaseViewModelcalculateAddressArgs {
  dataSourceAddress: Scalars['String']['input'];
}


export interface UseCaseViewModelcalculateDataArgs {
  data: Array<DataSetDataModelInput>;
}


export interface UseCaseViewModelcalculationArgs {
  calculationId: Scalars['ID']['input'];
}


export interface UseCaseViewModelcalculationsArgs {
  jobState?: InputMaybe<JobState>;
  scheduler?: InputMaybe<Scalars['String']['input']>;
  skipUntilId?: InputMaybe<Scalars['ID']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}


export interface UseCaseViewModelcalculationsCountArgs {
  jobState?: InputMaybe<JobState>;
  scheduler?: InputMaybe<Scalars['String']['input']>;
}


export interface UseCaseViewModeldataArgs {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  rules?: InputMaybe<Array<DataTags>>;
  skipUntilAddress?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}


export interface UseCaseViewModeldataCountArgs {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rules?: InputMaybe<Array<DataTags>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}


export interface UseCaseViewModelpublicApiRequestsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<TransactionFilterInput>;
}

export interface UseCaseViewModelMutations {
  __typename?: 'UseCaseViewModelMutations';
  addData?: Maybe<TableSetReference>;
  addDataFromAddress?: Maybe<TableSetReference>;
  deletePublicApiRequests?: Maybe<Array<Scalars['ID']['output']>>;
  patch?: Maybe<UseCaseViewModel>;
  patchFixedDataSourceFromJobResult?: Maybe<UseCaseViewModel>;
  scheduleCalculation?: Maybe<Scalars['ID']['output']>;
  scheduleCalculationByTags?: Maybe<Calculation>;
}


export interface UseCaseViewModelMutationsaddDataArgs {
  displayName: Scalars['String']['input'];
  tables: Array<AddDataTableInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}


export interface UseCaseViewModelMutationsaddDataFromAddressArgs {
  address: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}


export interface UseCaseViewModelMutationsdeletePublicApiRequestsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<TransactionFilterInput>;
}


export interface UseCaseViewModelMutationspatchArgs {
  argumentAddress: Scalars['String']['input'];
  entryPath: Scalars['String']['input'];
  patcherId: Scalars['ID']['input'];
}


export interface UseCaseViewModelMutationspatchFixedDataSourceFromJobResultArgs {
  calculationId: Scalars['ID']['input'];
  entryPath: Scalars['String']['input'];
}


export interface UseCaseViewModelMutationsscheduleCalculationArgs {
  dataSourceAddress: Scalars['String']['input'];
}


export interface UseCaseViewModelMutationsscheduleCalculationByTagsArgs {
  displayName?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
}

export interface UseCasesViewModel {
  __typename?: 'UseCasesViewModel';
  apiKeys?: Maybe<Array<ApiKey>>;
  calculationRule?: Maybe<CalculationRuleViewModel>;
  serviceProducts?: Maybe<SolutionServiceProductsViewModel>;
  transactions?: Maybe<Array<Transaction>>;
  useCase?: Maybe<UseCaseViewModel>;
  /** @deprecated Use CalculationRule.Schema instead */
  useCaseSchema?: Maybe<UseCaseSchema>;
  useCases?: Maybe<Array<UseCaseViewModel>>;
}


export interface UseCasesViewModelcalculationRuleArgs {
  calculationRuleAddress: Scalars['String']['input'];
}


export interface UseCasesViewModeltransactionsArgs {
  apiKeyId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  tableName?: InputMaybe<Scalars['String']['input']>;
  timestampRange?: InputMaybe<DateTimeRangeFilterInput>;
  useCaseKey?: InputMaybe<Scalars['Key']['input']>;
  useCaseVersions?: InputMaybe<Array<Scalars['SemverVersion']['input']>>;
}


export interface UseCasesViewModeluseCaseArgs {
  useCaseKey: Scalars['Key']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
}


export interface UseCasesViewModeluseCaseSchemaArgs {
  calculationRuleAddress: Scalars['String']['input'];
}


export interface UseCasesViewModeluseCasesArgs {
  latestVersionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  useCaseKey?: InputMaybe<Scalars['Key']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
}

export interface UseCasesViewModelMutations {
  __typename?: 'UseCasesViewModelMutations';
  addUseCase?: Maybe<UseCaseViewModel>;
  deleteUseCase?: Maybe<Array<Scalars['String']['output']>>;
  serviceProducts?: Maybe<SolutionServiceProductsViewModelMutations>;
  useCase?: Maybe<UseCaseViewModelMutations>;
  useCases?: Maybe<Array<UseCaseViewModelMutations>>;
}


export interface UseCasesViewModelMutationsaddUseCaseArgs {
  useCaseDefinition: UseCaseDefinitionInput;
}


export interface UseCasesViewModelMutationsdeleteUseCaseArgs {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  useCaseKey: Scalars['Key']['input'];
}


export interface UseCasesViewModelMutationsuseCaseArgs {
  useCaseKey: Scalars['Key']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
}


export interface UseCasesViewModelMutationsuseCasesArgs {
  latestVersionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  useCaseKey?: InputMaybe<Scalars['Key']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
}

export interface User {
  __typename?: 'User';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
}

export interface WorkspaceViewModel {
  __typename?: 'WorkspaceViewModel';
  capacity?: Maybe<CapacityViewModel>;
  id: Scalars['ID']['output'];
  isAvailable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  scaleInPolicy?: Maybe<ScalingPolicyViewModel>;
  scaleOutPolicy?: Maybe<ScalingPolicyViewModel>;
}

export interface WorkspaceViewModelMutations {
  __typename?: 'WorkspaceViewModelMutations';
  updateCapacity?: Maybe<CapacityViewModel>;
  updateScalingPolicy?: Maybe<ScalingPolicyViewModel>;
}


export interface WorkspaceViewModelMutationsupdateCapacityArgs {
  maxCapacity: Scalars['Int']['input'];
  minCapacity: Scalars['Int']['input'];
}


export interface WorkspaceViewModelMutationsupdateScalingPolicyArgs {
  scalingAdjustment: Scalars['Int']['input'];
  scalingType: ScalingType;
  threshold: Scalars['Int']['input'];
}

export interface WorkspacesViewModel {
  __typename?: 'WorkspacesViewModel';
  instance?: Maybe<Scalars['String']['output']>;
  workspace?: Maybe<WorkspaceViewModel>;
  workspaces: Array<WorkspaceViewModel>;
}


export interface WorkspacesViewModelworkspaceArgs {
  workspaceId: Scalars['ID']['input'];
}

export interface WorkspacesViewModelMutations {
  __typename?: 'WorkspacesViewModelMutations';
  workspace?: Maybe<WorkspaceViewModelMutations>;
  workspaces: Array<WorkspaceViewModelMutations>;
}


export interface WorkspacesViewModelMutationsworkspaceArgs {
  workspaceId: Scalars['ID']['input'];
}
